var o = /* @__PURE__ */ ((r) => (r.HOME = "home", r.VIEWER = "viewer", r.REPORTER = "reporter", r.WORKLIST = "worklist", r.PATIENT_JACKET = "patient-jacket", r.AI_SANDBOX = "ai-sandbox", r.PRODUCTPORTAL = "productportal", r.LOGIN = "login", r.ADMIN = "admin", r.UNKNOWN = "unknown", r))(o || {});
export {
  o as PageTypes
};
//# sourceMappingURL=pageTypes.js.map
